import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9ut9ansxk1: FaireBrandEntity = {
  token: "b_9ut9ansxk1",
  type: "brand",
  name: "The Endery",
  avatarUrl: "https://cdn.faire.com/fastly/d8edf97a92084b9805b1f4f072a0a4826c55db6fd7e096a93187999de469b240.png",
  bannerUrl: "https://cdn.faire.com/fastly/ab5704ce61e267edfe94e22cf199bf2d4e1c65c8c8fe5cf0281603ab8940df84.jpeg",
  logoUrl: "https://cdn.faire.com/fastly/d8edf97a92084b9805b1f4f072a0a4826c55db6fd7e096a93187999de469b240.png",
  heroImageUrl: "https://cdn.faire.com/fastly/ab5704ce61e267edfe94e22cf199bf2d4e1c65c8c8fe5cf0281603ab8940df84.jpeg",
  location: "New York, NY, USA",
  minimumOrderDollars: 500,
  rating: 5,
  reviewCount: 14,
  isTopShop: true,
  isInsider: true,
  description: "Our collections are made with at least 60% deadstock waste and ethically handcrafted by Peruvian artisans. The fashion industry is wasteful—around 15% of textiles are lost in production, and premium yarns like pima cotton, alpaca, and merino often go unused in the knitwear industry.\n\nWe’re not in the business of mass production. Instead, we work extensively with what’s already available—giving high-quality materials a second life through thoughtful, small-batch production. Our approach to slow fashion is intentional, responsible, and deeply connected to the hands that make each piece.\n\n*Please note that we cover all tariffs and duties - this is not charged to you separately. We believe in keeping things simple, meaning your order ships seamlessly from Peru to you with no extra costs, just beautiful knits.",
  meta: {
    source: "api",
    importedAt: "2026-10-13T05:50:15.238Z",
    importedBy: "entity-db-cli"
  }
};
